var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0115 13.0115C12.5018 13.5207 12.1864 14.2243 12.1863 15.0017C12.1863 16.5558 13.4457 17.816 14.9998 17.8162C15.7773 17.8161 16.4806 17.4999 16.99 16.99L19.6335 19.6335C18.4741 20.4395 16.9418 21.0036 14.9998 21.0037C9.74701 21.0036 6.49482 16.496 6.99487 14.9958C7.49516 13.4959 8.39036 11.7409 10.3669 10.3669L13.0115 13.0115ZM16.1941 16.1941C15.8885 16.5002 15.4665 16.6902 14.9998 16.6902C14.0674 16.69 13.3113 15.9341 13.3113 15.0017C13.3114 14.5351 13.5013 14.113 13.8074 13.8074L16.1941 16.1941Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8845 16.99C17.3942 16.4808 17.7096 15.7772 17.7097 14.9998C17.7097 13.4457 16.4503 12.1855 14.8962 12.1853C14.1187 12.1853 13.4154 12.5016 12.906 13.0115L10.2625 10.3679C11.4219 9.56197 12.9542 8.9978 14.8962 8.9978C20.149 8.99797 22.9949 13.1198 22.9949 14.9958C22.9948 16.1783 21.5056 18.2606 19.5291 19.6345L16.8845 16.99ZM13.7019 13.8074C14.0075 13.5012 14.4295 13.3113 14.8962 13.3113C15.8286 13.3114 16.5847 14.0673 16.5847 14.9998C16.5846 15.4664 16.3948 15.8885 16.0886 16.1941L13.7019 13.8074Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.57171c7c2633ed7a1f78270c617a3411.svg";
export { ForwardRef as ReactComponent };